import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from './AppLayout';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <AppLayout>
      <section style={styles.hero}>
        <div style={styles.badge}>Insurance Quote Demo</div>
        <h1 style={styles.title}>Get Covered in Minutes</h1>
        <p style={styles.subtitle}>
          Start your insurance quote online. Our consultant verifies your application and sends
          your personalized quote to your email.
        </p>

        <div style={styles.actions}>
          <button style={styles.primaryButton} onClick={() => navigate('/quote/start')}>
            Get A Quote
          </button>
          <button style={styles.secondaryButton} onClick={() => navigate('/consultant/login')}>
            Consultant Login
          </button>
        </div>
      </section>

      <section style={styles.cards}>
        <article style={styles.card}>
          <h3 style={styles.cardTitle}>Step 1: Customer Request</h3>
          <p style={styles.cardText}>Customer fills a multi-page quote application.</p>
        </article>

        <article style={styles.card}>
          <h3 style={styles.cardTitle}>Step 2: Consultant Verification</h3>
          <p style={styles.cardText}>Consultant reviews and verifies submitted applications.</p>
        </article>

        <article style={styles.card}>
          <h3 style={styles.cardTitle}>Step 3: Quote by Email</h3>
          <p style={styles.cardText}>Consultant calculates and emails the quote to customer.</p>
        </article>
      </section>
    </AppLayout>
  );
};

const styles = {
  hero: {
    background: 'linear-gradient(120deg, #eef9f2 0%, #e4f2fb 100%)',
    border: '1px solid #d4e8da',
    borderRadius: 14,
    padding: '32px 28px',
  },
  badge: {
    color: '#276c4b',
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 0.4,
    marginBottom: 10,
    textTransform: 'uppercase',
  },
  title: {
    color: '#155b3d',
    fontSize: 40,
    lineHeight: 1.15,
    margin: '0 0 12px 0',
    maxWidth: 780,
  },
  subtitle: {
    color: '#3d6652',
    fontSize: 17,
    lineHeight: 1.5,
    margin: '0 0 20px 0',
    maxWidth: 760,
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
  },
  primaryButton: {
    background: 'linear-gradient(90deg, #1f845b 0%, #2da56f 100%)',
    border: 'none',
    borderRadius: 10,
    color: '#fff',
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 700,
    padding: '12px 20px',
  },
  secondaryButton: {
    background: '#fff',
    border: '1px solid #bdd8c7',
    borderRadius: 10,
    color: '#236946',
    cursor: 'pointer',
    fontSize: 15,
    fontWeight: 700,
    padding: '12px 20px',
  },
  cards: {
    display: 'grid',
    gap: 12,
    gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
    marginTop: 16,
  },
  card: {
    background: '#f8fcf9',
    border: '1px solid #dbece2',
    borderRadius: 10,
    padding: 14,
  },
  cardTitle: {
    color: '#236946',
    fontSize: 17,
    margin: '0 0 8px 0',
  },
  cardText: {
    color: '#466856',
    fontSize: 14,
    lineHeight: 1.45,
    margin: 0,
  },
};

export default HomePage;
